import styled from 'styled-components'

export const JobNotesListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
